import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataTable from '../UIElements/DataTable';
import { useDispatch } from 'react-redux';
import { offlineUsers } from '../../features/dashboard/dashboardSlice';
import { SearchField } from './OnlineUsers';

function OfflineUsers() {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchParameters, setSearchParameters] = useState({
    search: '',
    pageNumber: 0,
    pageSize: 10,
  });
  async function getDetails(data) {
    try {
      setLoading(true);
      const response = await dispatch(offlineUsers(data)).unwrap();
      setData(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  const columns = [
    {
      field: 'sno',
      headerName: <div className='text-sm'>SNO</div>,
      width: 70,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className=' cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'customerName',
      headerName: <div className='text-sm'>Institute Name</div>,
      width: 240,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className=' cursor-default text-[14px] truncate'>
          {param.value}
        </div>
      ),
    },
    {
      field: 'code',
      headerName: <div className='text-sm'>License Key</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'validityDays',
      headerName: <div className='text-sm'>Plan</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'status',
      headerName: <div className='text-sm'>Status</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'activatedAt',
      headerName: <div className='text-sm'>Activated On</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'expiresAt',
      headerName: <div className='text-sm'>Expires On</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default truncate'>{param.value}</div>
      ),
    },
  ];
  useEffect(() => {
    getDetails(searchParameters);
  }, [searchParameters]);
  return (
    <>
      <div className='flex justify-between items-center'>
        <Typography variant='h6' className='text-[#1976d2]'>
          {' '}
          List of the Offline Users
        </Typography>
        <SearchField
          setSearchParameters={setSearchParameters}
          initialValue={searchParameters.search}
        />{' '}
      </div>{' '}
      <Box
        sx={{
          overflowX: 'scroll', // always show scrollbar
          whiteSpace: 'nowrap', // prevent wrapping
          '&::-webkit-scrollbar': {
            height: '4px', // customize scrollbar height
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
          },
        }}
      >
        <div style={{ minWidth: '1200px' }}>
          <DataTable
            rows={(data?.users || [])?.map((row, index) => ({
              sno:
                searchParameters.pageNumber * searchParameters.pageSize +
                index +
                1,
              ...row,
            }))}
            columns={columns}
            rowCount={data?.totalRecords || 0}
            paginationMode='server'
            page={searchParameters?.pageNumber}
            pageSize={searchParameters?.pageSize}
            loading={loading}
            hideColumnIcons={true}
            onPageChange={(e) => {
              setSearchParameters((prev) => ({
                ...prev,
                pageNumber: e?.page,
                pageSize: e?.pageSize,
              }));
            }}
          />
        </div>
      </Box>
    </>
  );
}
export default OfflineUsers;
